/* NZS-QAEXTRACT-0828: extracted verbatim from snippets/nzs-quick-add.liquid */

(function(){
  if(window.__nzsQA) return;
  window.__nzsQA = true;

  var backdrop = null, panel = null, overlay = null, rows = [], cur = null, busy = false, curPill = null;
  /* NZS-QA2-0809: subscribe state — per open session */
  var sub = { on:false, w:0 };
  /* NZS-QA2-0809: lazy card-transport cache, keyed by product handle */
  var famCache = {};
  /* NZS-QA3-CC-0812: byte-identical to the sheet @media in the <style> above. */
  var SHEET_MQ = '(max-width:760px), (hover:none) and (pointer:coarse)';
  /* NZS-QA3-CC-0812: one-token desktop switch — 'modal' (centred dialog) or 'anchor' (pill popover). */
  var DESKTOP_MODE = 'modal';

  function esc(s){
    s = (s === null || s === undefined) ? '' : String(s);
    return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function human(s){
    if(!s) return '';
    s = String(s).replace(/-/g,' ');
    return s.replace(/\w\S*/g, function(w){
      if(/^\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.substr(1).toLowerCase();
    });
  }

  function fmt(c){ return '$' + (c/100).toFixed(2); }
  function plansOf(r){ return (r && r.sp || []).slice().sort(function(a,b){ return a.w - b.w; }); }
  /* default cadence — same ladder as the cart drawer (NZS-CDR-SUBUP): largest plan week that fits
     the servings run-out (srv/7), else the first >=6 weeks, else the shortest plan */
  function defW(r){
    var ps = plansOf(r); if(!ps.length) return 0;
    var target = Math.floor((+r.srv || 0) / 7), pick = 0;
    ps.forEach(function(p){ if(p.w <= target && p.w > pick) pick = p.w; });
    if(!pick){ for(var i = 0; i < ps.length; i++){ if(ps[i].w >= 6){ pick = ps[i].w; break; } } }
    return pick || ps[0].w;
  }

  function ensureEls(){
    if(backdrop && panel) return;
    backdrop = document.createElement('div');
    backdrop.className = 'nzs-qa-bd';
    panel = document.createElement('div');
    panel.className = 'nzs-qa';
    panel.setAttribute('role','dialog');
    panel.setAttribute('aria-modal','true');
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    backdrop.addEventListener('click', close);

    panel.addEventListener('click', function(e){
      var chip = e.target.closest('[data-role]');
      if(chip){
        var u = chip.getAttribute('data-u');
        var row = rows.filter(function(r){ return r.u === u; })[0];
        if(row){
          cur = row;
          rows.forEach(function(r){ r.c = (r.u === cur.u); });
          /* NZS-POLISH-0923-QA3: the rebuild replaces every node; keep keyboard focus on the picked
             pill and the body's scroll position instead of dropping both. */
          var hadFocus = chip === document.activeElement, bodyEl = panel.querySelector('.nzs-qa__body');
          var st = bodyEl ? bodyEl.scrollTop : 0;
          build();
          bodyEl = panel.querySelector('.nzs-qa__body');
          if(bodyEl && st) bodyEl.scrollTop = st;
          if(hadFocus){
            var again = null;
            Array.prototype.forEach.call(panel.querySelectorAll('[data-role]'), function(b){
              if(!again && b.getAttribute('data-role') === chip.getAttribute('data-role') && b.getAttribute('data-u') === u) again = b;
            });
            if(again){ try{ again.focus({ preventScroll:true }); }catch(_){ again.focus(); } }
          }
        }
        return;
      }
      /* NZS-QA2-0809: subscribe pill toggle */
      var subBtn = e.target.closest('[data-qa-sub]');
      if(subBtn){
        sub.on = !sub.on;
        if(sub.on) sub.w = defW(cur);
        /* NZS-POLISH-0923-QA3: patch in place so the knob slides, the frequency row expands/collapses
           and focus stays on the toggle; full rebuild only if the expected nodes are missing. */
        if(!updSub()) build();
        return;
      }
      var atc = e.target.closest('.nzs-qa__atc');
      if(atc){
        if(atc.disabled) return;
        directAdd(cur && cur.v, atc);
        return;
      }
      var closeBtn = e.target.closest('.nzs-qa__close');
      if(closeBtn){ close(); return; }
    });

    /* NZS-QA2-0809: weeks slider — update text + state only, no rebuild mid-drag */
    panel.addEventListener('input', function(e){
      var rng = e.target.closest('[data-qa-subrange]');
      if(!rng) return;
      var ps = plansOf(cur), p = ps[+rng.value] || ps[0];
      if(!p) return;
      sub.w = p.w;
      var lab = panel.querySelector('[data-qa-subw]');
      if(lab) lab.textContent = p.w + (p.w === 1 ? ' week' : ' weeks');
    });

    if(window.nzsOverlay && typeof window.nzsOverlay.enhance === 'function'){
      overlay = window.nzsOverlay.enhance({
        root: panel,
        trigger: curPill,
        key: 'quickadd',
        label: 'Quick add',
        onOpen: show,
        onClose: hide,
        /* NZS-POLISH-0923-QA2: settle on the slide, release the scroll lock after the 220ms exit. */
        settleProp: 'transform',
        unlockDelay: 220
      });
    }
  }

  /* QA-FIRSTOPEN: strip the classes, force a reflow, then re-add next frame — otherwise the very
     first open lands .is-in in the same task as the append and the transition never runs. This IS
     nzsOverlay's onOpen hook (enhance() never touches display/visibility on the root). */
  function show(){
    if(curPill) curPill.setAttribute('aria-expanded','true');
    backdrop.classList.remove('is-in');
    panel.classList.remove('is-in');
    void panel.offsetWidth;
    window.requestAnimationFrame(function(){
      if(!curPill) return; /* closed again before the frame landed */
      backdrop.classList.add('is-in');
      panel.classList.add('is-in');
    });
  }

  function hide(){
    if(curPill) curPill.setAttribute('aria-expanded','false');
    if(panel && backdrop){
      backdrop.classList.remove('is-in');
      panel.classList.remove('is-in');
    }
    curPill = null;
  }

  function isSheet(){
    return window.matchMedia(SHEET_MQ).matches;
  }

  /* NZS-QA3-CC-0812: width lives in CSS (--nzs-qa-w); JS reads it so the two can never drift. */
  function qaWidth(){
    return parseInt(getComputedStyle(panel).getPropertyValue('--nzs-qa-w'), 10) || 340;
  }

  /* Flavour and size render as the same pill; data-role/data-u keep the delegated handler untouched. */
  function choices(list, role, factor){
    var h = '<div class="nzs-qa__choices">';
    list.forEach(function(r){
      var lab = role === 'size' ? esc(human(r.s)) : esc(human(r.f) || 'Original');
      /* NZS-QA2-0809: $/serve under each size (subscribe discount applied while on) */
      var ps = '';
      if(role === 'size' && +r.srv > 0 && +r.prc > 0){
        ps = '<span class="ps">$' + ((r.prc * factor) / r.srv / 100).toFixed(2) + '/serve</span>';
      }
      h += '<button type="button" class="nzs-qa__choice" data-role="' + role + '" data-u="' + esc(r.u) + '"'
        + ' aria-pressed="' + (r.u === cur.u ? 'true' : 'false') + '"' + (!r.a ? ' disabled' : '') + '>'
        + '<span>' + lab + '</span>' + ps + '</button>';
    });
    return h + '</div>';
  }

  /* NZS-POLISH-0923-QA3: header price, shared by build() and the in-place subscribe update. */
  function priceHtml(SUB_KEEP){
    /* NZS-QA2-0809: while subscribed the price flips to the -10% figure; struck price = RRP
       (or the one-time price on non-sale items) so the saving is legible */
    if(sub.on && cur.prc){
      var was = SUB_KEEP === 1 ? cur.cp : (cur.cp || cur.pr); /* NZS-SUBLOCK-STRIKE-0905 */
      return fmt(Math.round(cur.prc * SUB_KEEP)) + (was ? '<span class="was">' + esc(was) + '</span>' : '');
    }
    return esc(cur.pr) + (cur.cp ? '<span class="was">' + esc(cur.cp) + '</span>' : '');
  }

  function reducedMotion(){
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* NZS-POLISH-0923-QA3: subscribe toggle without a rebuild. Updates the price, the per-size $/serve,
     the pill state and opens/closes the frequency row (grid-rows collapse in CSS). Returns false when
     the panel is not in the expected shape so the caller can fall back to build(). */
  function updSub(){
    if(!panel || !cur) return false;
    var btn = panel.querySelector('[data-qa-sub]'), wrap = panel.querySelector('[data-qa-subx]'), p = panel.querySelector('.nzs-qa__p');
    var curPlans = plansOf(cur);
    if(!btn || !wrap || !p || !curPlans.length) return false;
    if(sub.on && !curPlans.some(function(pl){ return pl.w === sub.w; })) sub.w = defW(cur);
    var SUB_KEEP = window.__nzsSubLock ? 1 : 0.9; /* NZS-SUBLOCK-0905: 0% sale mode */
    var factor = sub.on ? SUB_KEEP : 1;
    p.innerHTML = priceHtml(SUB_KEEP);
    if(p.animate && !reducedMotion()){
      p.animate([{ opacity:.35, transform:'translateY(3px)' }, { opacity:1, transform:'none' }], { duration:200, easing:'cubic-bezier(.22,1,.36,1)' });
    }
    Array.prototype.forEach.call(panel.querySelectorAll('.nzs-qa__choice[data-role="size"]'), function(b){
      var ps = b.querySelector('.ps'), u = b.getAttribute('data-u');
      var r = rows.filter(function(x){ return x.u === u; })[0];
      if(ps && r && +r.srv > 0 && +r.prc > 0) ps.textContent = '$' + ((r.prc * factor) / r.srv / 100).toFixed(2) + '/serve';
    });
    btn.classList.toggle('is-on', sub.on);
    btn.setAttribute('aria-pressed', sub.on ? 'true' : 'false');
    if(sub.on){
      var idx = 0;
      curPlans.forEach(function(pl, i){ if(pl.w === sub.w) idx = i; });
      var rng = wrap.querySelector('[data-qa-subrange]'), lab = wrap.querySelector('[data-qa-subw]');
      if(rng) rng.value = idx;
      if(lab) lab.textContent = curPlans[idx].w + (curPlans[idx].w === 1 ? ' week' : ' weeks');
    }
    wrap.classList.toggle('is-open', sub.on);
    if(sub.on) wrap.removeAttribute('inert'); else wrap.setAttribute('inert', '');
    return true;
  }

  function build(){
    if(!panel || !cur) return;
    var famHasSize = rows.some(function(r){ return !!r.s; });
    var famHasFlav = rows.some(function(r){ return !!r.f; });

    /* NZS-QA2-0809: re-resolve subscribe state against the newly selected row */
    var curPlans = plansOf(cur);
    if(sub.on){
      if(!curPlans.length) sub.on = false;
      else if(!curPlans.some(function(p){ return p.w === sub.w; })) sub.w = defW(cur);
    }
    var SUB_KEEP = window.__nzsSubLock ? 1 : 0.9; /* NZS-SUBLOCK-0905: 0% sale mode */
    var factor = sub.on ? SUB_KEEP : 1;

    var flavRows = rows.filter(function(r){ return !famHasSize || r.s === cur.s; });
    var seenF = {}; var flavList = [];
    flavRows.forEach(function(r){
      var k = r.f || r.u;
      if(!seenF[k]){ seenF[k] = true; flavList.push(r); }
    });

    var sizeList = [];
    if(famHasSize){
      var sizeRows = rows.filter(function(r){ return !famHasFlav || r.f === cur.f; });
      var seenS = {};
      sizeRows.forEach(function(r){
        var k = r.s || r.u;
        if(!seenS[k]){ seenS[k] = true; sizeList.push(r); }
      });
    }

    var html = '';
    html += '<button type="button" class="nzs-qa__close" aria-label="Close" data-nzs-autofocus><span class="nzs-qa__close-x">&times;</span></button>';
    html += '<div class="nzs-qa__head' + (cur.th ? '' : ' nzs-qa__head--noimg') + '">';
    if(cur.th){ html += '<img class="nzs-qa__thumb" src="' + esc(cur.th) + '" alt="">'; }
    html += '<div>';
    html += '<div class="nzs-qa__t">' + esc(cur.t) + '</div>';
    html += '<div class="nzs-qa__p">' + priceHtml(SUB_KEEP) + '</div>'; /* NZS-POLISH-0923-QA3 */
    /* NZS-QA-TAGS: chips follow the selected row, so swapping flavour/size updates them */
    var qaTags = '';
    var qaSv = +(cur.sv || 0);
    if(qaSv > 0) qaTags += '<span class="nzs-qa__tag nzs-qa__tag--save">Save ' + qaSv + '%</span>';
    if(!cur.a) qaTags += '<span class="nzs-qa__tag nzs-qa__tag--out">Sold out</span>';
    if(qaTags) html += '<div class="nzs-qa__tags">' + qaTags + '</div>';
    html += '</div>';
    html += '</div>';

    html += '<div class="nzs-qa__body">';

    if(flavList.length > 1){
      html += '<fieldset class="nzs-qa__group"><legend class="nzs-qa__legend">' + esc(cur.option_label || 'Flavour') + '</legend>' + choices(flavList, 'flav', factor) + '</fieldset>';
    }

    if(sizeList.length > 1){
      html += '<fieldset class="nzs-qa__group"><legend class="nzs-qa__legend">Size</legend>' + choices(sizeList, 'size', factor) + '</fieldset>';
    }

    /* NZS-QA2-0809: subscribe pill + weeks slider — only when the selected row has weekly 10% plans.
       Adaptive label: on-sale rows (cp set) read "an additional 10%" (the 10% stacks on the sale price). */
    if(curPlans.length){
      var subLab = window.__nzsSubLock ? esc(window.__nzsSubLockLabel || 'Subscribe to lock in this price') : (cur.cp ? 'Subscribe &amp; save an additional 10%' : 'Subscribe &amp; save 10%');
      html += '<div class="nzs-qa__group">';
      html += '<button type="button" class="nzs-qa__sub' + (sub.on ? ' is-on' : '') + '" data-qa-sub aria-pressed="' + (sub.on ? 'true' : 'false') + '"><span class="nzs-qa__sub-dot"></span><span>' + subLab + '</span></button>';
      /* NZS-POLISH-0923-QA3: the frequency row is always rendered inside a grid-rows collapse
         (inert + closed while one-time) so toggling can animate it in AND out. */
      var idx = 0, wSel = sub.on ? sub.w : defW(cur);
      curPlans.forEach(function(p, i){ if(p.w === wSel) idx = i; });
      html += '<div class="nzs-qa__subx' + (sub.on ? ' is-open' : '') + '" data-qa-subx' + (sub.on ? '' : ' inert') + '><div class="nzs-qa__subx-in">';
      html += '<div class="nzs-qa__subfreq"><span>Auto-ship every</span>';
      if(curPlans.length > 1){
        html += '<input type="range" data-qa-subrange min="0" max="' + (curPlans.length - 1) + '" step="1" value="' + idx + '" aria-label="Delivery frequency">';
      }
      html += '<b data-qa-subw>' + curPlans[idx].w + (curPlans[idx].w === 1 ? ' week' : ' weeks') + '</b></div>';
      html += '</div></div>';
      html += '</div>';
    }

    html += '</div>';

    html += '<div class="nzs-qa__foot">';
    html += '<div class="nzs-qa__status" data-qa-status role="status" aria-live="polite"></div>';
    /* Belt-and-braces flight source for nzs-fly-to-cart.js: the head thumb never scrolls away. */
    html += '<button type="button" class="nzs-qa__atc" data-nzs-fly-from=".nzs-qa__thumb"' + (!cur.a ? ' disabled' : '') + '>' + (cur.a ? 'Add to cart' : 'Sold out') + '</button>';
    html += '</div>';

    panel.innerHTML = html;
  }

  function position(pill){
    if(!panel) return;
    panel.classList.remove('is-sheet','nzs-qa--modal');
    if(isSheet()){
      panel.classList.add('is-sheet');
      panel.style.left = '';
      panel.style.top = '';
      return;
    }
    if(DESKTOP_MODE === 'modal'){
      panel.classList.add('nzs-qa--modal');
      panel.style.left = '';
      panel.style.top = '';
      return;
    }
    /* 'anchor': the legacy pill-anchored popover — same clamp/flip maths, minus the display juggling
       (QA-DISPLAY: the panel is only opacity-hidden, so offsetHeight already measures). */
    var r = pill.getBoundingClientRect();
    var w = qaWidth();
    var left = Math.min(Math.max(r.right - w, 8), window.innerWidth - w - 8);
    var top = r.bottom + 8;

    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
    var panelH = panel.offsetHeight;

    if(top + panelH > window.innerHeight - 8){
      top = Math.max(8, r.top - panelH - 8);
      panel.style.top = top + 'px';
    }
  }

  function open(pill){
    if(curPill && curPill !== pill) curPill.setAttribute('aria-expanded','false');
    curPill = pill;
    ensureEls();
    build();
    /* NZS-POLISH-0923-QA5: a sheet<->modal switch while closed would otherwise start a transform
       transition on the hidden panel and the next open would slide in from a skewed start. */
    var wasMode = panel.className;
    position(pill);
    if(panel.className !== wasMode){ panel.style.transition = 'none'; void panel.offsetWidth; panel.style.transition = ''; }
    pill.setAttribute('aria-expanded','true');
    if(overlay){ overlay.open({ trigger: pill }); return; }
    show();
  }

  /* NZS-QA2-0809: single entry for every surface — legacy sibling-JSON tiles and the lazy card path */
  function openWithData(data, trigger){
    rows = data;
    cur = rows.filter(function(r){ return r.c; })[0] || rows[0];
    sub.on = false; sub.w = 0;
    open(trigger);
  }

  function close(options){
    if(overlay){ overlay.close(options); return; }
    hide();
  }

  function handleOf(vid, el){
    /* NZS-QA2-0809: card buttons carry the handle directly */
    var dh = el && el.getAttribute && el.getAttribute('data-handle');
    if(dh) return dh;
    var url=(cur&&String(cur.v)===String(vid)&&cur.u)||'';
    var card=el&&el.closest&&el.closest('.nzs-bs__card');
    var link=card&&card.querySelector('a[href*="/products/"]');
    if(!url&&link) url=link.getAttribute('href')||'';
    var match=url.split('?')[0].match(/\/products\/([^\/?#]+)/);
    return match?match[1]:'';
  }

  function directAdd(vid, el){
    if(busy || !vid) return;
    busy = true;
    var isOpenPill = el && el.hasAttribute && el.hasAttribute('data-nzs-qa-add');
    var orig = el ? el.innerHTML : null; /* NZS-POLISH-0923-QA4: keep inner spans for the error reset */
    /* NZS-SPEED-LDR: panel and pill both use the global loadOn/loadOff contract. */
    if(el && window.__nzsLoadOn) window.__nzsLoadOn(el);
    var item = { id: +vid, quantity: 1 };
    /* NZS-QA2-0809: subscription — nzsATC forwards selling_plan verbatim (and its 422 self-heal
       copies every item key), so no engine change is needed. */
    if(sub.on){
      var ps = plansOf(cur), pl = null;
      ps.forEach(function(p){ if(p.w === sub.w) pl = p; });
      pl = pl || ps[0];
      if(pl) item.selling_plan = pl.id;
    }
    var add=window.nzsATC
      ? window.nzsATC.add({ items: [item] }, { handle: handleOf(vid,el) })
      : Promise.reject(new Error('Please try again'));
    add.then(function(){
      if(el && window.__nzsLoadOff) window.__nzsLoadOff(el);
      ['cart:refresh','cart:build','cart:updated'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev)); });
      /* NZS-CART-MOTION-0913: release the picker before opening cart; never restore focus over it. */
      close({ restoreFocus: false });
      var t = document.getElementById('nzsCartToggle');
      var d = document.getElementById('nzsCartDrawer');
      if(t && !(d && d.classList.contains('is-open'))) t.click();
      /* NZS-SPEED-LDR: preserve the pill's success lock without extending it to panel adds. */
      if(isOpenPill) setTimeout(function(){ busy = false; }, 1500);
      else busy = false;
    }).catch(function(err){
      if(el && window.__nzsLoadOff) window.__nzsLoadOff(el);
      /* NZS-QA3-CC-0812: panel adds report into the reserved status line (no label swap on the
         gradient pill); card pills keep the label swap. */
      var st = panel && el && panel.contains(el) ? panel.querySelector('[data-qa-status]') : null;
      if(st){
        st.textContent = err.message;
        st.classList.add('is-err');
        setTimeout(function(){
          if(st.isConnected){ st.textContent = ''; st.classList.remove('is-err'); }
          busy = false;
        }, 2500);
      } else if(el){
        el.textContent = err.message;
        el.title = err.message;
        setTimeout(function(){ el.innerHTML = orig; el.removeAttribute('title'); busy = false; }, 2500); /* NZS-POLISH-0923-QA4 */
      } else {
        busy = false;
      }
    });
  }

  /* NZS-QA2-0809: lazy card path — fetch the family rows once per handle from the tiny
     ?view=nzs-qa transport (templates/product.nzs-qa.liquid), then open the same popover.
     Any failure falls back to a plain direct add: the button is never dead. */
  function cardOpen(btn){
    var handle = btn.getAttribute('data-handle') || '';
    var vid = btn.getAttribute('data-vid') || '';
    if(!handle){ directAdd(vid, btn); return; }
    function go(data){
      /* lone product: popover only when there is something to choose (siblings or a subscription) */
      if(data.length > 1 || (data[0] && data[0].sp && data[0].sp.length)){
        openWithData(data, btn);
      } else {
        directAdd(vid, btn);
      }
    }
    if(famCache[handle]){ go(famCache[handle]); return; }
    if(btn.dataset.nzsQaBusy) return;
    btn.dataset.nzsQaBusy = '1';
    if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
    fetch('/products/' + handle + '?view=nzs-qa', { credentials: 'same-origin' })
      .then(function(r){ if(!r.ok) throw new Error('bad'); return r.text(); })
      .then(function(txt){
        var data = JSON.parse(txt);
        if(!data || !data.length) throw new Error('empty');
        famCache[handle] = data;
        if(window.__nzsLoadOff) window.__nzsLoadOff(btn);
        delete btn.dataset.nzsQaBusy;
        go(data);
      })
      .catch(function(){
        if(window.__nzsLoadOff) window.__nzsLoadOff(btn);
        delete btn.dataset.nzsQaBusy;
        directAdd(vid, btn);
      });
  }

  document.addEventListener('click', function(e){
    var addBtn = e.target.closest('[data-nzs-qa-add]');
    if(addBtn){
      var vid = addBtn.getAttribute('data-vid');
      directAdd(vid, addBtn);
      return;
    }
    /* NZS-QA2-0809: collection/search card buttons */
    var cardBtn = e.target.closest('[data-nzs-qa-card]');
    if(cardBtn){
      e.preventDefault();
      cardOpen(cardBtn);
      return;
    }
    var openBtn = e.target.closest('[data-nzs-qa-open]');
    if(openBtn){
      var card = openBtn.closest('.nzs-bs__card');
      if(!card) return;
      var script = card.querySelector('script[type="application/json"][data-nzs-qa-data]');
      if(!script) return;
      var data;
      try{ data = JSON.parse(script.textContent); }catch(_){ data = []; }
      if(!data || !data.length) return;
      openWithData(data, openBtn);
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !overlay) close();
  });

  /* NZS-QA3-CC-0812: a bottom sheet must survive the scroll its own body causes. */
  window.addEventListener('scroll', function(){ if(!overlay && panel && !panel.classList.contains('is-sheet')) close(); }, { passive: true });
  window.addEventListener('resize', function(){ if(!overlay) close(); });
  document.addEventListener('scroll', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('nzs-bs__track')){
      close();
    }
  }, true);
})();
